import { z } from 'zod'

export const ICD10_RAF_WEIGHTS_MAX_CODES = 100

export const icd10RafWeightSchema = z.object({
  code: z.string(),
  v22: z.number().nullable(),
  v28: z.number().nullable(),
})

export const icd10RafWeightsRequestSchema = z.object({
  codes: z
    .array(z.string().trim().min(1))
    .min(1)
    .max(ICD10_RAF_WEIGHTS_MAX_CODES),
})

export const icd10RafWeightsResponseSchema = z.object({
  weights: z.array(icd10RafWeightSchema),
})

export type Icd10RafWeight = z.infer<typeof icd10RafWeightSchema>
export type Icd10RafWeightsRequest = z.infer<
  typeof icd10RafWeightsRequestSchema
>
export type Icd10RafWeightsResponse = z.infer<
  typeof icd10RafWeightsResponseSchema
>
